<!-- 召回通知单列表 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                             slot="append" icon="el-icon-search"
                                             :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                       :disabled="formOneValue.isChange == 0" @visible-change="selectChange"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                          :key="matItem.key"
                                          :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                          :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                    </el-select>
                                    <el-date-picker v-else-if="formOneValue.fieldType == 'date'"
                                       v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期"
                                       format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                    </el-date-picker>
                                    <el-input class="form_codition" v-else type="text"
                                       @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                       v-model.trim="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength"
                                       :disabled="formOneValue.isChange == 0"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                          formOneValue.fieldType, formOneValue.formatterContent) }}
                                    </span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :footFlag="false"
               :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
               @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
   name: "baseprolineAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         detaislDataInfo: {},
         showTabs: "",
         formDataList: [],
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         seId: "",
         seType: "",
         seIndex: "",
         sField: "", // 赋值字段
         fField: "", //焦点字段
         parentSearchData: {},
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         requesUrl: "",
         token: {
            token: sessionStorage.getItem("token"),
         },
         inputel: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      imgur() {
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val && (val != "" || val != undefined)) {
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val, flag) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.$set(this.sendDataInfo, item, val[item])
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex, this.fField);
         });
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField, fField) {
         this.parentSearchData = {}
         if (type == 'salesName') {
            if (this.sendDataInfo.cmId == '' || this.sendDataInfo.cmId == null) {
               return this.$message.error("请先选择客户");
            }
            this.parentSearchData.unitId = this.sendDataInfo.cmId;
         }
         if (type == 'opmName') {
            this.parentSearchData.opmSalesperson = 1
            this.parentSearchData.opmBuyer = ""
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },


      initActionBox(sendDataInfo) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
               // this.$message({
               //     type: 'info',
               //     message: '取消关闭'
               // });
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";

            var dataInfo = JSON.parse(JSON.stringify(oldData));

            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.sendDataInfo.rcnId = dataInfo.rcnId
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
               this.initFocus();
            }, 16.7);
         });
      },
      sendDataAction(sendDataInfo) {
         console.log(sendDataInfo);
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               this.$message({
                  message: "请完善主表单必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.baseprolineadd(sendData);
         } else {
            var responseData = await this.$http.baseprolineupdate(sendData);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message.success("操作成功");
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'bgiType' || fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });

            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               // if (key.jurconfigform[index].isShow == 1)
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

            }
         });
         var arr = [];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 输入框切换焦点
      nextFocus(index, fField) {
         if (fField == "keydown") {
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgur();
      this.$nextTick(() => {
         this.openBox();

      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>